import { useEffect, useState } from 'react';

const PermissionCell = ({ permissions = [], permissionsRoles = [], setPermissionsSave}) => {
  const [checks, setChecks] = useState([]);
  const permissionsKey = permissions.map((permission) => permission.Id).join('|');
  const permissionsRolesKey = permissionsRoles.map((permission) => permission.Id).join('|');

  useEffect(() => {
    setChecks(
      permissions?.map(p => ({
        ...p,
        checked: permissionsRoles.some(pr => pr.Id === p.Id)
      })) || []
    )
  }, [permissionsKey, permissionsRolesKey])

  useEffect(() => {
    setPermissionsSave(prevs => [
      ...prevs,
      ...checks
        .filter(ch => ch.checked && !prevs.includes(ch.Id))
        .map(ch => ch.Id)
    ])
  }, [checks])

  const updateCheck = (id, isCheck) => {
    setChecks(prev =>
      prev.map(item =>
        item.Id === id ? { ...item, checked: isCheck } : item
      )
    )
    setPermissionsSave(prevsp =>
      isCheck
        ? (prevsp.includes(id) ? prevsp : [...prevsp, id])
        : prevsp.filter(pr => pr !== id)
    )
  }

  return {
    permissions: checks,
    isEmpty: !checks || checks.length === 0,
    isSingle: checks?.length === 1,
    isMultiple: checks?.length > 1,
    updateCheck
  };
};

export default PermissionCell;
